'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

require('../../src/styles/external.scss');

var _sanitizeHtml = require('sanitize-html');

var _sanitizeHtml2 = _interopRequireDefault(_sanitizeHtml);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PracticeExpandableSection = function PracticeExpandableSection(props) {
    var title = props.title,
        text = props.text,
        expanded = props.expanded,
        className = props.className,
        onClick = props.onClick,
        active = props.active;

    return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(
            'div',
            { className: (active ? _style2.default.activePracticeSection : '') + ' ' + _style2.default.expandableSubsection },
            _react2.default.createElement(
                'div',
                { className: _style2.default.aboutSection },
                _react2.default.createElement(
                    'h2',
                    null,
                    title
                ),
                _react2.default.createElement('div', { className: expanded === false ? _style2.default.textBlock : _style2.default.textBlockExpanded, dangerouslySetInnerHTML: { __html: (0, _sanitizeHtml2.default)(text) } }),
                _react2.default.createElement(
                    'a',
                    { onClick: onClick },
                    _react2.default.createElement(
                        'h3',
                        null,
                        expanded ? '- Read Less' : '+ Read More'
                    )
                )
            )
        )
    );
};

PracticeExpandableSection.propTypes = {
    title: require('react').PropTypes.string.isRequired,
    text: require('react').PropTypes.string.isRequired,
    expanded: require('react').PropTypes.bool.isRequired,
    className: require('react').PropTypes.string.isRequired,
    onClick: require('react').PropTypes.func.isRequired,
    active: require('react').PropTypes.bool.isRequired
};
PracticeExpandableSection.displayName = 'PracticeExpandableSection';

PracticeExpandableSection.defaultProps = {
    title: '',
    text: '',
    expanded: false,
    className: 'expandableSection'
};

exports.default = (0, _reactIntl.injectIntl)(PracticeExpandableSection);


// WEBPACK FOOTER //
// ./components/profile-right-section/lib/components/practice-expandable-section.js